import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=67373e6e&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67373e6e')) {
      api.createRecord('67373e6e', component.options)
    } else {
      api.reload('67373e6e', component.options)
    }
    module.hot.accept("./calendar.vue?vue&type=template&id=67373e6e&", function () {
      api.rerender('67373e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/calendar.vue"
export default component.exports